








































import { Vue, Component, Watch } from "@/shared/vuepack";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import Button from "@/shared/components/ui/Button.vue";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import HsabBiometricAuthSetup from "@/shared/components/HsabBiometricAuthSetup.vue";
import { AuthType } from "@/shared/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useBiometricAuthStore } from "@/shared/store/biometricAuth";

@Component({
  components: {
    SettingsNavigation,
    Button,
    SettingsHeader,
    HsabBiometricAuthSetup
  },
})
export default class BiometricAuthSettings extends Vue {
 userStore = useUserStore();
 bioAuthStore = useBiometricAuthStore();


  notifierStore = useNotifierStore();
  isEnabled: boolean = null;

  get showSetupScreen () {
    return !this.bioAuthStore.biometricAuthEnabled && this.isOkta;
  }

  get isOkta () {
    return this.userStore.authType === AuthType.Okta;
  }

  get displaySetupFromLoginMessage () {
    return !this.bioAuthStore.biometricAuthEnabled && !this.isOkta;
  }

  disable () {
    this.bioAuthStore.disableBiometricAuth()
      .then(() => {
        this.notifierStore.setSuccess("You have successfully disabled " + this.bioAuthStore.getBiometryType.displayValue);
        this.isEnabled = false;
      })
      .catch(() => this.notifierStore.setDanger("Unable to disable"));
  }

  mounted () {
    this.bioAuthStore.loadBiometricSettings();
    this.isEnabled = this.bioAuthStore.biometricAuthEnabled;
  }

  @Watch("bioAuthStore.isBiometricAuthSettingsLoaded")
  isLoadedChanged () {
    this.bioAuthStore.loadBiometricSettings();
    this.isEnabled = this.bioAuthStore.biometricAuthEnabled;
  }
}
